<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h1>Services</h1>
            <p>Digital solutions to start, run and grow your business</p>
        </div>
    </div>
</div>


<section class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <div class="icon">
                        <!-- <img src="assets/img/icon1.png" alt="image"> -->
                    </div>
                    <h2>Web Design &amp; Development</h2>
                    <p>Your website reflects you. Enhance your business, brand and your image with a custom designed
                        website representing your values and showcasing your prowess. It’s time to turn the big ideas in
                        your mind into a digital reality with Webstazy One. It’s the century of the web. Embrace its
                        power and stay ahead of the competition.
                        All our products are uniquely catered to your needs. Webstazy One offers comprehensive packages
                        including graphic design, digital marketing, technical support, complementary hosting and email
                        services in order to grow your business and brand image.</p>
                    <div class="row">



                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Branding Websites
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Online Stores
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Mission Critical Web Applications
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Online Platforms
                            </div>
                        </div>
                        <!-- <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> React Web Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Angular Web Development
                            </div>
                        </div> -->
                    </div>
                    <a routerLink="/service-web-design" class="default-btn" aria-label="Learn more about Web Design &amp; Development"><i class="bx bxs-spreadsheet" aria-hidden="true"></i>Learn More<span></span></a>
                </div>
            </div>
            <div class="services-image wow fadeInRight" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/services-image/web designArtboard 1.png"
                        alt="Web design and development illustration">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="services-area bg-left-color bg-left-shape bg-f4f6fc ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-image wow fadeInLeft" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/services-image/mobile application developmentArtboard 1.png"
                        alt="Mobile application development illustration">
                </div>
            </div>
            <div class="services-content it-service-content">
                <div class="content">
                    <div class="icon">
                        <!-- <img src="assets/img/icon1.png" alt="image"> -->
                    </div>
                    <h2>Mobile Application Development</h2>
                    <p>Reach your customers and the target audience anywhere, anytime with the power of mobility.
                        Release your own mobile application to stand out of the competition. If you desire to go mobile
                        with your business or have the next big mobile idea we are here to support you make it a
                        reality. We provide mobile application development solutions from custom platforms, aggregate
                        networks and Augmented Reality(AR) / Virtual Reality(VR) applications to simple mobile tools
                        harnessing the power of portability and integrated sensors. Whether you want to target android
                        users or ios users we have the solutions for your business. Want to target a niche market? Not a
                        problem. We know the mobile market and we are ready to guide you to harness the best out of it.

                    </p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Platforms &amp; Aggregate Networks
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Android App Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> iOS App Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Hybrid App Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> AR/VR App Development
                            </div>
                        </div>
                    </div>
                    <a routerLink="/service-mobile-application" class="default-btn" aria-label="Learn more about Mobile Application Development"><i class="bx bxs-spreadsheet" aria-hidden="true"></i>Learn More<span></span></a>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <div class="icon">
                        <!-- <img src="assets/img/icon1.png" alt="image"> -->
                    </div>
                    <h2>Custom Cloud Based Solutions</h2>
                    <p>Automate and streamline your business processes, increasing productivity and cutting costs with
                        an off the shelf or custom cloud based solution tailor-made just for your business. We have a
                        solution for any business challenge you are facing with flexible payment plans to match your
                        financial progress.</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Point Of Sales
                            </div>
                        </div>

                    </div>
                    <a routerLink="/service-custom-cloudbased-sol" class="default-btn" aria-label="Learn more about Custom Cloud Based Solutions"><i class="bx bxs-spreadsheet" aria-hidden="true"></i>Learn More<span></span></a>
                </div>
            </div>
            <div class="services-image wow fadeInRight" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/services-image/custom cloud caseArtboard 1.png"
                        alt="Custom cloud-based solutions illustration">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="services-area bg-left-color bg-left-shape bg-f4f6fc ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-image wow fadeInLeft" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/services-image/digital media marcketingArtboard 1.png"
                        alt="Digital media marketing and branding illustration">
                </div>
            </div>
            <div class="services-content it-service-content">
                <div class="content">
                    <div class="icon">
                        <!-- <img src="assets/img/icon1.png" alt="image"> -->
                    </div>
                    <h2>Digital Media Marketing &amp; Branding Solutions</h2>
                    <p>Spend your marketing budget effectively and efficiently with our digital marketing solutions suite,
                        including:</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Social Media Marketing
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Search Engine Optimization
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Viral Marketing
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Inbound marketing
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Branding Material
                            </div>
                        </div>
                    </div>
                    <a routerLink="/service-digital-media" class="default-btn" aria-label="Learn more about Digital Media Marketing"><i class="bx bxs-spreadsheet" aria-hidden="true"></i>Learn More<span></span></a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <div class="icon">
                        <!-- <img src="assets/img/icon1.png" alt="image"> -->
                    </div>
                    <h2>Digital Infrastructure &amp; Business Process Management</h2>
                    <p>Do you find it challenging to manage “technical stuff”? Do you feel that you don’t have the
                        resources to carry out technical operations of your business? We are here to help.</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Network Management &amp; security
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Data Backup Solutions
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> General IT services
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Data &amp; Content Management
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Call Center On Site Technical Support
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> On Site Technical Support
                            </div>
                        </div>
                    </div>
                    <a routerLink="/service-digital-infrastructure" class="default-btn" aria-label="Learn more about Digital Infrastructure &amp; Business Process Management"><i class="bx bxs-spreadsheet" aria-hidden="true"></i>Learn More<span></span></a>
                </div>
            </div>
            <div class="services-image wow fadeInRight" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/services-image/digita infarstructureArtboard 1.png"
                        alt="Digital infrastructure and business process management illustration">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>Not sure which service you need?</h2>
            <p>Tell us what you want to achieve and we'll recommend the right mix of solutions.</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
        </div>
    </div>
</section>
